<!--
 * @Author: liushuang
 * @Date: 2023-02-13 09:53:55
 * @LastEditors: liushuang
 * @Description: 
 * @FilePath: \Ats-web\src\views\position\entryPostionCom.vue
-->
<template>
<div :class="isMax?'isMax':'isMoadl'">
  <div class="center-title">
    <span>{{title}}</span>
    <span v-if="!isMax">
      <svg @click.stop='minOperation' t="1675991873943" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11850" width="22" height="22"><path d="M829.160727 880.360727L584.145455 635.345455a36.212364 36.212364 0 1 1 51.2-51.2l245.015272 245.015272a36.212364 36.212364 0 1 1-51.2 51.2z" fill="#A2A5B4" p-id="11851"></path><path d="M790.109091 612.864h-206.848a36.212364 36.212364 0 0 1 0-72.424727h206.848a36.212364 36.212364 0 0 1 0 72.424727z" fill="#A2A5B4" p-id="11852"></path><path d="M615.936 787.083636v-206.894545a36.212364 36.212364 0 0 0-72.424727 0v206.894545a36.212364 36.212364 0 0 0 72.424727 0z" fill="#A2A5B4" p-id="11853"></path><path d="M182.132364 127.860364l245.015272 245.015272a36.212364 36.212364 0 1 1-51.2 51.2L130.932364 179.060364a36.212364 36.212364 0 1 1 51.2-51.2z" fill="#A2A5B4" p-id="11854"></path><path d="M221.184 395.357091h206.848a36.212364 36.212364 0 0 1 0 72.424727H221.184a36.212364 36.212364 0 0 1 0-72.424727z" fill="#A2A5B4" p-id="11855"></path><path d="M395.357091 221.184v206.848a36.212364 36.212364 0 0 0 72.424727 0V221.184a36.212364 36.212364 0 0 0-72.424727 0z" fill="#A2A5B4" p-id="11856"></path></svg>
      <svg @click.stop='maxOperation' t="1675991924873" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11993" width="22" height="22"><path d="M793.6 847.127273l-179.2-179.2a36.212364 36.212364 0 0 1 51.2-51.2l179.2 179.2a36.212364 36.212364 0 1 1-51.2 51.2z" fill="#A2A5B4" p-id="11994"></path><path d="M830.696727 655.825455v206.848a36.212364 36.212364 0 0 0 72.424728 0v-206.894546a36.212364 36.212364 0 0 0-72.424728 0z" fill="#A2A5B4" p-id="11995"></path><path d="M656.523636 829.998545h206.848a36.212364 36.212364 0 0 1 0 72.378182h-206.848a36.212364 36.212364 0 0 1 0-72.378182zM339.456 392.983273L193.163636 246.690909a36.212364 36.212364 0 1 1 51.2-51.2l146.292364 146.292364a36.212364 36.212364 0 0 1-51.2 51.2z" fill="#A2A5B4" p-id="11996"></path><path d="M370.874182 195.956364H164.026182a36.212364 36.212364 0 0 1 0-72.378182h206.848a36.212364 36.212364 0 0 1 0 72.378182z" fill="#A2A5B4" p-id="11997"></path><path d="M196.701091 370.176V163.281455a36.212364 36.212364 0 0 0-72.424727 0v206.894545a36.212364 36.212364 0 0 0 72.424727 0z" fill="#A2A5B4" p-id="11998"></path><path d="M847.872 233.053091l-179.2 179.2a36.212364 36.212364 0 0 1-51.2-51.2l179.2-179.2a36.212364 36.212364 0 1 1 51.2 51.2z" fill="#A2A5B4" p-id="11999"></path><path d="M656.523636 195.956364h206.848a36.212364 36.212364 0 0 0 0-72.378182h-206.848a36.212364 36.212364 0 0 0 0 72.378182z" fill="#A2A5B4" p-id="12000"></path><path d="M830.696727 370.176V163.281455a36.212364 36.212364 0 0 1 72.424728 0v206.894545a36.212364 36.212364 0 0 1-72.424728 0z" fill="#A2A5B4" p-id="12001"></path><path d="M393.681455 687.243636l-146.245819 146.245819a36.212364 36.212364 0 1 1-51.2-51.2l146.245819-146.245819a36.212364 36.212364 0 0 1 51.2 51.2z" fill="#A2A5B4" p-id="12002"></path><path d="M196.701091 655.825455v206.848a36.212364 36.212364 0 0 1-72.424727 0v-206.894546a36.212364 36.212364 0 0 1 72.424727 0z" fill="#A2A5B4" p-id="12003"></path><path d="M370.874182 829.998545H164.026182a36.212364 36.212364 0 0 0 0 72.378182h206.848a36.212364 36.212364 0 0 0 0-72.378182z" fill="#A2A5B4" p-id="12004"></path></svg>
      <svg @click.stop='closeMoadl' t="1675991965229" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12141" width="22" height="22"><path d="M230.385866 742.382499m25.606007-25.606007l460.776492-460.776492q25.606008-25.606008 51.212016 0l0 0q25.606008 25.606008 0 51.212016l-460.776492 460.776491q-25.606008 25.606008-51.212016 0l0 0q-25.606008-25.606008 0-51.212015Z" fill="#A2A5B4" p-id="12142"></path><path d="M716.801278 768.02142L255.991873 307.212016a36.212364 36.212364 0 0 1 51.212016-51.212016l460.776492 460.776492a36.212364 36.212364 0 0 1-51.212016 51.212015z" fill="#A2A5B4" p-id="12143"></path></svg>
    </span>
  </div>
  <div class="custormForm">
    <a-form 
      v-if="!loadingEdit" 
      :model="ruleForm" 
      :colon= false 
      :rules="rules" 
      ref='modalFormRef' 
      autocomplete="off"
      scrollToFirstError
    >
      <!-- 基本信息 -->
      <div class="custorm-base item-one-box" v-if="setItem.project_job_info.show">
        <div class="custorm-add-title">
          <svg t="1676253408455" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3140" xmlns:xlink="http://www.w3.org/1999/xlink" width="22" height="22"><path d="M597.333333 149.333333c47.146667 0 85.333333 31.829333 85.333334 71.125334V298.666667h128a85.333333 85.333333 0 0 1 85.333333 85.333333v426.666667a85.333333 85.333333 0 0 1-85.333333 85.333333H213.333333a85.333333 85.333333 0 0 1-85.333333-85.333333V384a85.333333 85.333333 0 0 1 85.333333-85.333333h128V220.458667c0-39.253333 38.186667-71.125333 85.333334-71.125334h170.666666z m234.666667 426.666667h-640V810.666667a21.333333 21.333333 0 0 0 17.493333 20.992L213.333333 832h597.333334a21.333333 21.333333 0 0 0 20.992-17.493333L832 810.666667v-234.666667z m-21.333333-213.333333H213.333333a21.333333 21.333333 0 0 0-20.992 17.493333L192 384v128h640V384a21.333333 21.333333 0 0 0-17.493333-20.992L810.666667 362.666667zM597.333333 213.333333h-170.666666c-10.453333 0-19.2 5.034667-20.992 11.648l-0.341334 2.56V298.666667h213.333334V227.541333c0-6.954667-7.552-12.8-17.493334-13.994666L597.333333 213.333333z" fill="#333333" p-id="3141"></path></svg>
          <h3>基本信息</h3>
        </div>
        <div class="custorm-content addContent" id="baseInfo">
          <a-form-item 
            label="职位名称" 
            :name="['baseInfo', 'title']"
            v-if="setItem.name.show" 
            :rules="setItem.name.notNull?rules.title:[{ required: false }]"
          >
            <a-input v-model:value="ruleForm.baseInfo.title" placeholder="请输入职位名称" maxlength="40" />
          </a-form-item>
          <a-form-item 
            label="所属客户" 
            :name="['baseInfo', 'customerId']" 
            :rules="rules.customerId"
          >
            <a-select 
              v-model:value="ruleForm.baseInfo.customerId" 
              placeholder="请选择所属客户" 
              :getPopupContainer="
                triggerNode => {
                  return triggerNode.parentNode
                }"
              @select="companyNameChange"
            >
              <template #suffixIcon><caret-down-outlined class="ant-select-suffix"/></template>
              <a-select-option v-for="item in clientSelect" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item 
            class="item-txt" 
            label="招聘数量" 
            :name="['baseInfo', 'personNum']" 
            v-if="setItem.recruitNum.show" 
            :rules="setItem.recruitNum.notNull ? rules.personNum : [{ required: false }]"
          >
            <a-input 
              v-model:value="ruleForm.baseInfo.personNum" 
              placeholder="请输入招聘数量" 
              maxlength="4"
              @input="restrictInput"
            /><span class="right_text">人</span>
          </a-form-item>
          <a-form-item 
            label="工作城市" 
            :name="['baseInfo', 'cityCodes']" 
            v-if="setItem.city.show"
            :rules="setItem.city.notNull?rules.cityCodes:[{ required: false }]"
          >
            <city-list 
              :selectNum='3'
              :oldSelData="ruleForm.baseInfo.cities"
              @searchCityhandle="searchCityhandle"
            ></city-list>
          </a-form-item>
          <a-form-item 
            label="职位类别"  
            :name="['baseInfo', 'professionCategory']" 
            v-if="setItem.professionCategory.show"
            :rules="setItem.professionCategory.notNull?rules.professionCategory:[{ required: false }]"
          >
            <job-category 
              :selecNum='1'
              :oldJobCategory="ruleForm.baseInfo.professionCategory" 
              @searchJobTypehandle="searchTypehandle"
            ></job-category>
          </a-form-item>
          <a-form-item 
            label="学历要求" 
            :name="['baseInfo', 'educationType']"
            v-if="setItem.educationalRequirements.show"
            :rules="setItem.educationalRequirements.notNull?rules.educationType:[{ required: false }]"
          >
            <a-select 
              v-model:value="ruleForm.baseInfo.educationType" 
              placeholder="请选择学历要求" 
              :options="educationTypeSelect"
              :field-names="{ label: 'dicValue', value: 'dicKey' }"
              :getPopupContainer="
                  triggerNode => {
                    return triggerNode.parentNode
                }"
            >
              <template #suffixIcon><caret-down-outlined class="ant-select-suffix"/></template>
            </a-select>
          </a-form-item>
          <a-form-item 
            class="tow-item-box"
            v-if="setItem.salary.show"
          >
            <template #label><span class="item-xing" v-if="setItem.salary.notNull">*</span>职位年薪</template>
            <div class="peer-wrap">
              <a-form-item 
                ref="salaryMinRef" 
                :name="['baseInfo', 'salaryMin']" 
                :rules="setItem.salary.notNull || ruleForm.baseInfo.salaryMin? rules.salaryMin:[{ required: false }]"
              >
                <a-input 
                  v-model:value="ruleForm.baseInfo.salaryMin" 
                  placeholder="最低年薪"
                  maxlength="6"
                  @input="salarySpceMin"
                /><span class="right_text">万</span>
              </a-form-item>
              <span class="center_text">-</span>
              <a-form-item  
                ref="salaryMaxRef" 
                :name="['baseInfo', 'salaryMax']"
                :rules="setItem.salary.notNull || ruleForm.baseInfo.salaryMax?rules.salaryMax:[{ required: false }]"
              >
                <a-input 
                  v-model:value="ruleForm.baseInfo.salaryMax" 
                  placeholder="最高年薪"
                  maxlength="6"
                  @input="salarySpceMax"
                /><span class="right_text">万</span>
              </a-form-item>
            </div>
          </a-form-item>
          <a-form-item 
            class="tow-item-box"
            v-if="setItem.experience.show"
          >
            <template #label><span class="item-xing" v-if="setItem.experience.notNull">*</span>经验要求</template>
            <div class="peer-wrap">
              <a-form-item 
                ref="experienceMinRef" 
                :name="['baseInfo', 'experienceMin']"
                :rules="setItem.experience.notNull || ruleForm.baseInfo.experienceMin?rules.experienceMin:[{ required: false }]"
              >
                <a-input 
                v-model:value="ruleForm.baseInfo.experienceMin" 
                oninput="value=value.replace(/^\.+|[^\d]+/g,'')" 
                maxlength="3"
                placeholder="最低经验"/><span class="right_text">年</span>
              </a-form-item>
              <span class="center_text">-</span>
              <a-form-item 
                ref="experienceMaxRef" 
                :name="['baseInfo', 'experienceMax']"
                :rules="setItem.experience.notNull || ruleForm.baseInfo.experienceMax?rules.experienceMax:[{ required: false }]"
              >
                <a-input 
                v-model:value="ruleForm.baseInfo.experienceMax" 
                oninput="value=value.replace(/^\.+|[^\d]+/g,'')" 
                maxlength="3"
                placeholder="最高经验"/><span class="right_text">年</span>
              </a-form-item>
            </div>
          </a-form-item>
          <a-form-item 
            class="tow-item-box"
            v-if="setItem.age.show"
          >
            <template #label><span class="item-xing" v-if="setItem.age.notNull">*</span>年龄要求</template>
            <div class="peer-wrap">
              <a-form-item 
                ref="ageMinRef"  
                :name="['baseInfo', 'ageMin']"
                :rules="setItem.age.notNull || !validater.isEmpty(ruleForm.baseInfo.ageMin)?rules.ageMin:[{ required: false }]"
              >
                <a-input 
                v-model:value="ruleForm.baseInfo.ageMin" 
                oninput="value=value.replace(/^\.+|[^\d]+/g,'')" 
                maxlength="3"
                placeholder="最低年龄"/><span class="right_text">岁</span>
              </a-form-item>
              <span class="center_text">-</span>
              <a-form-item 
                ref="ageMaxRef"
                :name="['baseInfo', 'ageMax']"
                :rules="setItem.age.notNull || ruleForm.baseInfo.ageMax?rules.ageMax:[{ required: false }]"
              >
                <a-input 
                v-model:value="ruleForm.baseInfo.ageMax" 
                maxlength="3"
                oninput="value=value.replace(/^\.+|[^\d]+/g,'')" 
                placeholder="最高年龄"/><span class="right_text">岁</span>
              </a-form-item>
            </div>
          </a-form-item>
        </div>
      </div>
      <!-- 项目信息 -->
      <div class="custorm-base item-tow-box" v-if="setItem.project_project_info.show">
        <div class="custorm-add-title">
          <svg t="1676259520979" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3275" xmlns:xlink="http://www.w3.org/1999/xlink" width="22" height="22"><path d="M448 288m32 0l213.333333 0q32 0 32 32l0 0q0 32-32 32l-213.333333 0q-32 0-32-32l0 0q0-32 32-32Z" fill="#333333" p-id="3276"></path><path d="M448 480m32 0l213.333333 0q32 0 32 32l0 0q0 32-32 32l-213.333333 0q-32 0-32-32l0 0q0-32 32-32Z" fill="#333333" p-id="3277"></path><path d="M448 672m32 0l213.333333 0q32 0 32 32l0 0q0 32-32 32l-213.333333 0q-32 0-32-32l0 0q0-32 32-32Z" fill="#333333" p-id="3278"></path><path d="M362.666667 320m-42.666667 0a42.666667 42.666667 0 1 0 85.333333 0 42.666667 42.666667 0 1 0-85.333333 0Z" fill="#333333" p-id="3279"></path><path d="M362.666667 512m-42.666667 0a42.666667 42.666667 0 1 0 85.333333 0 42.666667 42.666667 0 1 0-85.333333 0Z" fill="#333333" p-id="3280"></path><path d="M362.666667 704m-42.666667 0a42.666667 42.666667 0 1 0 85.333333 0 42.666667 42.666667 0 1 0-85.333333 0Z" fill="#333333" p-id="3281"></path><path d="M794.069333 85.333333C838.570667 85.333333 874.666667 120.064 874.666667 162.901333v698.197334C874.666667 903.936 838.570667 938.666667 794.069333 938.666667H229.973333C185.429333 938.666667 149.333333 903.936 149.333333 861.098667V162.901333C149.333333 120.064 185.429333 85.333333 229.930667 85.333333H794.026667z m0 58.197334H229.973333a19.968 19.968 0 0 0-19.84 15.872l-0.298666 3.498666v698.197334a19.626667 19.626667 0 0 0 16.512 19.072l3.626666 0.298666H794.026667c9.898667 0 18.133333-6.826667 19.84-15.872l0.298666-3.498666V162.901333a19.626667 19.626667 0 0 0-16.512-19.072l-3.626666-0.298666z" fill="#333333" p-id="3282"></path></svg>
          <h3>项目信息</h3>
        </div>
        <div class="custorm-content addContent" id="extraInfo">
          <a-form-item 
            :name="['extraInfo', 'priority']"
            v-if="setItem.priority.show"
            :rules="setItem.priority.notNull?rules.priority:[{ required: false }]"
          >
            <template #label>优<i class="space-font1" />先<i class="space-font1" />级</template>
            <a-select 
              v-model:value="ruleForm.extraInfo.priority" 
              placeholder="请选择优先级" 
              :options="prioritySelect"
              :field-names="{ label: 'dicValue', value: 'dicKey' }"
              :getPopupContainer="
                triggerNode => {
                  return triggerNode.parentNode
              }"
            >
              <template #suffixIcon><caret-down-outlined class="ant-select-suffix"/></template>
            </a-select>
          </a-form-item>
          <a-form-item 
            label="项目状态" 
            :name="['extraInfo', 'projectStatus']" 
            v-if="setItem.status.show"
            :rules="setItem.status.notNull?rules.projectStatus:[{ required: false }]"
          >
            <a-select 
              v-model:value="ruleForm.extraInfo.projectStatus" 
              placeholder="请选择项目状态" 
              :options="statusSelect"
              :field-names="{ label: 'dicValue', value: 'dicKey' }"
              :getPopupContainer="
                triggerNode => {
                  return triggerNode.parentNode
              }"
            >
              <template #suffixIcon><caret-down-outlined class="ant-select-suffix"/></template>
            </a-select>
          </a-form-item>
          <a-form-item 
            :name="['extraInfo', 'customerContactsId']"
            class="item-add-five-box" 
            v-if="setItem.clientContact.show && ruleForm.baseInfo.customerId" 
            :rules="setItem.clientContact.notNull?rules.customerContactsId:[{ required: false }]"
          >
            <template #label>客户联系人</template>
            <a-select 
              mode="multiple"
              v-model:value="ruleForm.extraInfo.customerContactsId" 
              option-label-prop="label"
              placeholder="请选择客户联系人"
              :getPopupContainer="
                triggerNode => {
                  return triggerNode.parentNode
              }"
            >
              <template #suffixIcon ><caret-down-outlined class="ant-select-suffix"/></template>
              <a-select-option 
                v-for="item1 in contactsSelect" 
                :key="item1.id" 
                :value="item1.id"
                :label="item1.name"
                option-label-prop="label"
              >{{ item1.name }}<span class="icon-status" v-if="item1.valid == 0">(已失效)</span></a-select-option>
              <template #dropdownRender="{ menuNode: menu }">
                <v-nodes :vnodes="menu" />
                <a-divider style="margin: 4px 0" />
                <div
                  class="add-custer-link"
                  style="padding: 4px 8px; cursor: pointer; margin-bottom: -8px;"
                  @mousedown="e => e.preventDefault()"
                  @click="addItem"
                >
                  <plus-outlined />
                  新增
                </div>
              </template>
            </a-select>
          </a-form-item>
          <a-form-item 
            class="tow-item-box item-add-five-box"
            v-if="setItem.participator.show"
          >
            <template #label><span class="item-xing" v-if="setItem.participator.notNull">*</span>项目参与者</template>
            <div 
              class="participant-warp" 
              v-for="(partInfo, index) in ruleForm.extraInfo.participatorsOld" 
              :key='index'
            >
              <a-form-item 
                class="item-width-box" 
                :name="['extraInfo', 'participatorsOld', index, 'positionId']" 
                :rules="setItem.participator.notNull ? rules.positionId : [{ required: false }]"
              >
                <a-select 
                  v-model:value="partInfo.positionId" 
                  @select="value => searchpositionName(value, index)"
                  :getPopupContainer="
                    triggerNode => {
                      return triggerNode.parentNode
                  }"
                  placeholder="请选择"
                >
                  <a-select-option 
                  v-for="item2 in participantTypeSelect"
                  :key="item2.id" 
                  :value="item2.id">{{ item2.name }}</a-select-option>
                  <template #suffixIcon><caret-down-outlined class="ant-select-suffix"/></template>
                </a-select>
              </a-form-item>
              <a-form-item 
                class="select-center-box" 
                :class="index+1 !== ruleForm.extraInfo.participatorsOld.length ? 'select-conter-box1' : ''" 
                :name="['extraInfo','participatorsOld' , index, 'userId']" 
                :rules="setItem.participator.notNull ? rules.userId : [{ required: false }]"
              >
                <a-select
                  v-model:value="partInfo.userId"
                  show-search               
                  placeholder="请输入"
                  :filter-option="filterOption"
                  option-label-prop="label"
                  :getPopupContainer="
                    triggerNode => {
                      return triggerNode.parentNode
                  }"
                  @click="getParticipantName(ruleForm.extraInfo.participatorsOld[index].positionId, '')"
                >
                  <a-select-option 
                    v-for="item1 in participantNameSelect" 
                    :key="item1.id" 
                    :value="item1.id"
                    :label="item1.name"
                  ><img class="img-phone" :src="item1.headPhoto" />{{ item1.name }}<span class="icon-status" v-if="item1.accountStatus == 0">(已关闭)</span><span class="icon-status" v-if="item1.staffStatus == 0">(已离职)</span></a-select-option>
                  <template #suffixIcon>
                    <svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <title>icon/搜索</title>
                        <g id="icon/搜索" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <path d="M10.4172942,9.60068923 C10.4466684,9.62125122 10.4754552,9.64416315 10.5013046,9.6711875 L13.8288229,12.9981183 C14.0526549,13.2219503 14.0561798,13.5973536 13.8270604,13.8264729 C13.7176586,13.9371034 13.5686661,13.9995542 13.4130779,14 C13.2574898,14.0004364 13.1081456,13.9388313 12.9981183,13.8288229 L9.67060001,10.5013046 C9.64486557,10.4755763 9.62165201,10.4474447 9.6012767,10.4172942 C8.55161259,11.2807959 7.23405595,11.7519008 5.87485573,11.7497114 C2.63017291,11.7497114 0,9.11953854 0,5.87485573 C0,2.63017291 2.63017291,0 5.87485573,0 C9.11953854,0 11.7497115,2.63017291 11.7497114,5.87485573 C11.7497114,7.2889335 11.2503487,8.58668912 10.4172942,9.60068923 Z M5.87485573,10.5747403 C8.47053031,10.5747403 10.5747403,8.4705303 10.5747403,5.87485572 C10.5747403,3.27918114 8.47053031,1.17497114 5.87485573,1.17497114 C3.27918115,1.17497114 1.17497115,3.27918114 1.17497115,5.87485572 C1.17497115,8.4705303 3.27918115,10.5747403 5.87485573,10.5747403 Z" id="形状" fill="#A2A5B4" fill-rule="nonzero"></path>
                        </g>
                    </svg>
                  </template>
                </a-select>
              </a-form-item>
                <svg width="22px" height="22px" v-if="index+1 == ruleForm.extraInfo.participatorsOld.length" @click="addShare" class="icon icon-add" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <title>icon/添加</title>
                    <g id="icon/添加" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <rect id="矩形" fill="#D8D8D8" opacity="0" x="0" y="0" width="22" height="22"></rect>
                        <g class="blur-svg" id="添加" transform="translate(2.000000, 2.000000)" fill="#A2A5B4">
                            <path d="M9,0 C13.9705627,0 18,4.02943725 18,9 C18,13.9705627 13.9705627,18 9,18 C4.02943725,18 0,13.9705627 0,9 C0,4.02943725 4.02943725,0 9,0 Z M9,1.5 C4.85786438,1.5 1.5,4.85786438 1.5,9 C1.5,13.1421356 4.85786438,16.5 9,16.5 C13.1421356,16.5 16.5,13.1421356 16.5,9 C16.5,4.85786438 13.1421356,1.5 9,1.5 Z" id="椭圆形" fill-rule="nonzero"></path>
                            <rect id="矩形" x="4.5" y="8.25" width="9" height="1.5" rx="0.75"></rect>
                            <rect id="矩形备份-37" transform="translate(9.000000, 9.000000) rotate(-90.000000) translate(-9.000000, -9.000000) " x="4.5" y="8.25" width="9" height="1.5" rx="0.75"></rect>
                        </g>
                    </g>
                </svg>
                <svg width="22px" height="22px" @click="deleteShare(index)" class="icon icon-del" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <title>icon/关闭弹窗</title>
                    <g id="icon/关闭弹窗" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="编组-19">
                            <rect id="矩形" fill="#D8D8D8" opacity="0" x="1.65934391" y="1.66971481" width="18.667619" height="18.667619"></rect>
                            <g id="编组-17" class="blur-svg" transform="translate(11.000000, 11.000000) rotate(-45.000000) translate(-11.000000, -11.000000) translate(3.221825, 3.221825)" fill="#A2A5B4">
                                <rect id="矩形备份-38" x="0" y="7.00035713" width="15.5563492" height="1.55563492" rx="0.777817459"></rect>
                                <path d="M0.777817459,7.00035713 L14.7785317,7.00035713 C15.2081084,7.00035713 15.5563492,7.34859787 15.5563492,7.77817459 C15.5563492,8.20775131 15.2081084,8.55599205 14.7785317,8.55599205 L0.777817459,8.55599205 C0.348240738,8.55599205 -1.8189368e-12,8.20775131 -1.8189894e-12,7.77817459 C-1.81904201e-12,7.34859787 0.348240738,7.00035713 0.777817459,7.00035713 Z" id="矩形备份-39" transform="translate(7.778175, 7.778175) rotate(-90.000000) translate(-7.778175, -7.778175) "></path>
                            </g>
                        </g>
                    </g>
                </svg>
            </div>
            <div v-if="ruleForm.extraInfo.participatorsOld.length == 0" class="participant-warp1">
              <svg width="22px" height="22px" @click="addShare" class="icon icon-add" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <title>icon/添加</title>
                  <g id="icon/添加" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <rect id="矩形" fill="#D8D8D8" opacity="0" x="0" y="0" width="22" height="22"></rect>
                      <g id="添加" transform="translate(2.000000, 2.000000)" fill="#A2A5B4">
                          <path d="M9,0 C13.9705627,0 18,4.02943725 18,9 C18,13.9705627 13.9705627,18 9,18 C4.02943725,18 0,13.9705627 0,9 C0,4.02943725 4.02943725,0 9,0 Z M9,1.5 C4.85786438,1.5 1.5,4.85786438 1.5,9 C1.5,13.1421356 4.85786438,16.5 9,16.5 C13.1421356,16.5 16.5,13.1421356 16.5,9 C16.5,4.85786438 13.1421356,1.5 9,1.5 Z" id="椭圆形" fill-rule="nonzero"></path>
                          <rect id="矩形" x="4.5" y="8.25" width="9" height="1.5" rx="0.75"></rect>
                          <rect id="矩形备份-37" transform="translate(9.000000, 9.000000) rotate(-90.000000) translate(-9.000000, -9.000000) " x="4.5" y="8.25" width="9" height="1.5" rx="0.75"></rect>
                      </g>
                  </g>
              </svg>
            </div>
          </a-form-item>
        </div>
      </div>
      <!-- 详细信息 -->
      <div class="custorm-base item-three-box" v-if="setItem.project_job_detail.show">
        <div class="custorm-add-title">
          <svg t="1676259947615" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3416" xmlns:xlink="http://www.w3.org/1999/xlink" width="22" height="22"><path d="M448 277.333333a42.666667 42.666667 0 0 1 42.666667 42.666667v128a42.666667 42.666667 0 0 1-42.666667 42.666667H320a42.666667 42.666667 0 0 1-42.666667-42.666667v-128a42.666667 42.666667 0 0 1 42.666667-42.666667h128zM426.666667 341.333333h-85.333334v85.333334h85.333334V341.333333z" fill="#333333" p-id="3417"></path><path d="M789.333333 128a85.333333 85.333333 0 0 1 85.333334 85.333333v597.333334a85.333333 85.333333 0 0 1-85.333334 85.333333H234.666667a85.333333 85.333333 0 0 1-85.333334-85.333333V213.333333a85.333333 85.333333 0 0 1 85.333334-85.333333h554.666666z m0 64H234.666667a21.333333 21.333333 0 0 0-20.992 17.493333L213.333333 213.333333v597.333334a21.333333 21.333333 0 0 0 17.493334 20.992L234.666667 832h554.666666a21.333333 21.333333 0 0 0 20.992-17.493333L810.666667 810.666667V213.333333a21.333333 21.333333 0 0 0-17.493334-20.992L789.333333 192z" fill="#333333" p-id="3418"></path><path d="M554.666667 352m32 0l149.333333 0q32 0 32 32l0 0q0 32-32 32l-149.333333 0q-32 0-32-32l0 0q0-32 32-32Z" fill="#333333" p-id="3419"></path><path d="M277.333333 554.666667m32 0l426.666667 0q32 0 32 32l0 0q0 32-32 32l-426.666667 0q-32 0-32-32l0 0q0-32 32-32Z" fill="#333333" p-id="3420"></path><path d="M277.333333 682.666667m32 0l426.666667 0q32 0 32 32l0 0q0 32-32 32l-426.666667 0q-32 0-32-32l0 0q0-32 32-32Z" fill="#333333" p-id="3421"></path></svg>
          <h3>详细信息</h3>
        </div>
        <div class="custorm-content" id="description">
          <a-form-item 
            label="职位描述" 
            :name="['detailInfo', 'projectDescription']"
            v-if="setItem.description.show"
            :rules="setItem.description.notNull?rules.projectDescription:[{ required: false }]"
          >
            <a-textarea
              v-model:value="ruleForm.detailInfo.projectDescription"
              placeholder="请填写职位描述"
              maxlength="5000"
              :auto-size="{ minRows: 2, maxRows: 5 }"
            />
          </a-form-item>
          <a-form-item 
            label="任职要求" 
            :name="['detailInfo', 'projectRequire']"
            v-if="setItem.requirements.show"
            :rules="setItem.requirements.notNull?rules.requirement:[{ required: false }]"
          >
            <a-textarea
              v-model:value="ruleForm.detailInfo.projectRequire"
              placeholder="请填写任职要求"
              maxlength="5000"
              :auto-size="{ minRows: 2, maxRows: 5 }"
            />
          </a-form-item>
          <a-form-item 
            label="面试流程" 
            :name="['detailInfo', 'interviewProcess']" 
            v-if="setItem.interviewProcess.show"
            :rules="setItem.interviewProcess.notNull?rules.interviewProcess:[{ required: false }]"
          >
            <a-textarea
              v-model:value="ruleForm.detailInfo.interviewProcess"
              placeholder="请填写面试流程"
              maxlength="5000"
              :auto-size="{ minRows: 2, maxRows: 5 }"
            />
          </a-form-item>
          <a-form-item 
            class="upload-box" 
            :name="['detailInfo', 'Importance']" 
            v-if="setItem.attachment.show"
            :rules="setItem.attachment.notNull?rules.Importance:[{ required: false }]"
          >
            <template #label>附<i class="space-font"/>件</template>
            <appendix-upload
              :oldFileList="ruleForm.detailInfo.attachments"
              :fileTips="uploadType"
              :fileSize="uploadSize"
              :uploadMaxNum="uploadNum"
              @fileUploadM="fileUploadM"
              @rightChaClick="rightChaClick"
            ></appendix-upload>
          </a-form-item>
        </div>
      </div>
    </a-form>
  </div>
  <!-- 按钮 -->
  <div class="btn-item" >
    <a-button 
      class="mainBtn" 
      type="primary" 
      @click="handleSaveJob" 
      :loading='loading'
    >保存</a-button>
  </div>

  <!-- 添加客户联系人弹窗 -->
  <perMoadl 
    v-if="isShowPer"
    :isShowMoadl='isShowPer' 
    @closeMoadl="moadlShow('isShowPer', false)" 
    :customerId='ruleForm.baseInfo.customerId'
    @saveCantactHandle="saveCantactHandle"/>
</div>

</template>
<script>
import { defineComponent, reactive, toRefs, ref, onMounted, getCurrentInstance } from 'vue'
import { CaretDownOutlined, PlusOutlined } from '@ant-design/icons-vue';
import { validater } from "@/utils/validater.js"
import CityList from '@/components/search/city.vue'
import JobCategory from '@/components/search/jobCategory.vue'
import AppendixUpload from '@/components/upload/appendix.vue'
import getAdd from "@/composables/add"
import perMoadl from "@/views/custorm/pers/perMoadl.vue"
import { message } from "ant-design-vue"
import { useRouter } from "vue-router"
import { getDicList } from '@/composables/base'
import {
  fieldSettingsListApi, //查询字段设置列表
  selectCustomerContactsApi, //客户联系人下拉框
  projectDropdownListApi, //参与者-获取职位下拉框
  userSearchApi, //查询公司所有用户
} from '@/api/comm'
import {
  userProjectApi, //参与者-用户下拉框
  projectDetailApi, //职位-详情
  projectUpdataeApi, //职位-编辑
  projectSaveApi, //职位-录入
} from '@/api/position'
import {
  selectcustomerApi, //客户下拉框
} from '@/api/customer'
export default defineComponent({
  components: {
    CaretDownOutlined,
    PlusOutlined,
    CityList,
    JobCategory,
    AppendixUpload,
    perMoadl,
    VNodes: (_, { attrs }) => {
      return attrs.vnodes;
    },
  },
  props: {
    addPar: Object
  },
  setup(props) {
    const personNumVal = (rule, value) => {
      if (validater.isEmpty(value)) {
        return Promise.reject("请输入招聘数量");
      } else if (!validater.min(value, 0) || !validater.max(value, 9999)) {
        return Promise.reject("0-9999之间的整数");
      } else {
        return Promise.resolve()
      }
    }
    const salaryMinVal = (rule, value) => {
      let salaryMaxC = data.ruleForm.baseInfo.salaryMax;
      if (validater.isEmpty(value)) {
        return Promise.reject("请输入最低年薪");
      } else if (!validater.towDecimal(value)) {
        return Promise.reject("最多输入2位小数");
      } else if (!validater.min(value, 0) || !validater.max(value, 999)) {
        return Promise.reject("0-999之间的数");
      } else if (validater.minAnd(value, salaryMaxC) && !validater.isEmpty(salaryMaxC)) {
        return Promise.reject("不能大于最高年薪");
      } else if (!validater.min(value, salaryMaxC) && !validater.isEmpty(salaryMaxC)) {
        salaryMaxRef.value.clearValidate();
        return Promise.resolve()
      } else {
        return Promise.resolve()
      }
    }
    const salaryMaxVal = (rule, value) => {
      let salaryMinC = data.ruleForm.baseInfo.salaryMin;
      if (validater.isEmpty(value)) {
        return Promise.reject("请输入最高年薪");
      } else if (!validater.towDecimal(value)) {
        return Promise.reject("最多输入2位小数");
      } else if (!validater.min(value, 0) || !validater.max(value, 999)) {
        return Promise.reject("0-999之间的数");
      } else if (validater.maxAnd(value, salaryMinC) && !validater.isEmpty(salaryMinC)) {
        return Promise.reject("不能小于最低年薪");
      } else if (!validater.max(value, salaryMinC) && !validater.isEmpty(salaryMinC)) {
        salaryMinRef.value.clearValidate();
        return Promise.resolve()
      } else {
        return Promise.resolve()
      }
    }
    const experienceMinVal = (rule, value) => {
      let experienceMaxVal = data.ruleForm.baseInfo.experienceMax
      if (validater.isEmpty(value)) {
        return Promise.reject("请输入最小经验");
      } else if (!validater.min(value, 0) || !validater.max(value, 99)) {
        return Promise.reject("0-99之间的整数");
      } else if (validater.minAnd(value, experienceMaxVal) && !validater.isEmpty(experienceMaxVal)) {
        return Promise.reject("不能大于最大经验");
      } else if (!validater.min(value, experienceMaxVal) && !validater.isEmpty(experienceMaxVal)) {
        experienceMaxRef.value.clearValidate();
        return Promise.resolve()
      } else {
        return Promise.resolve()
      }
    }
    const experienceMaxVal = (rule, value) => {
      let experienceMinVal = data.ruleForm.baseInfo.experienceMin
      if (validater.isEmpty(value)) {
        return Promise.reject("请输入最大经验");
      } else if (!validater.min(value, 0) || !validater.max(value, 99)) {
        return Promise.reject("0-99之间的整数");
      } else if (validater.maxAnd(value, experienceMinVal) && !validater.isEmpty(experienceMinVal)) {
        return Promise.reject("不能小于最小经验");
      } else if (!validater.max(value, experienceMinVal) && !validater.isEmpty(experienceMinVal) && !validater.maxAnd(experienceMinVal, 0) && !validater.minAnd(experienceMinVal, 99)) {
        experienceMinRef.value.clearValidate();
        return Promise.resolve()
      } else {
        return Promise.resolve()
      }
    }
    const ageMinVal = (rule, value) => {
      let ageMaxC = data.ruleForm.baseInfo.ageMax;
      if (validater.isEmpty(value)) {
        return Promise.reject("请输入最小年龄");
      } else if (!validater.min(value, 18) || !validater.max(value, 100)) {
        return Promise.reject("18-100之间的整数");
      } else if (validater.minAnd(value, ageMaxC) && !validater.isEmpty(ageMaxC)) {
        return Promise.reject("不能大于最大年龄");
      } else if (!validater.min(value, ageMaxC) && !validater.isEmpty(ageMaxC)) {
        ageMaxRef.value.clearValidate();
        return Promise.resolve()
      } else {
        return Promise.resolve()
      }
    }
    const ageMaxVal = (rule, value) => {
      let ageMinVal = data.ruleForm.baseInfo.ageMin;
      if (validater.isEmpty(value)) {
        return Promise.reject("请输入最大年龄");
      } else if (!validater.min(value, 18) || !validater.max(value, 100)) {
        return Promise.reject("18-100之间的整数");
      } else if (validater.maxAnd(value, ageMinVal) && !validater.isEmpty(ageMinVal)) {
        return Promise.reject("不能小于最小年龄");
      } else if (!validater.max(value, ageMinVal) && !validater.isEmpty(ageMinVal) && !validater.maxAnd(ageMinVal, 18) && !validater.minAnd(ageMinVal, 100)) {
        ageMinRef.value.clearValidate();
        return Promise.resolve()
      } else {
        return Promise.resolve()
      }
    }
    const fileVal = () => {
      if (data.ruleForm.detailInfo.attachments.length > 0 || data.uploadFlie.length > 0) {
        return Promise.resolve()
      } else {
        return Promise.reject("请上传职位附件");
      }
    }
    const cityVal = () => {
      if (data.ruleForm.baseInfo.cities.length > 0) {
        return Promise.resolve()
      } else {
        return Promise.reject("请选择工作城市");
      }
    }
    const rules = {
      baseInfo: {
        title: [{ required: true, message: "请输入职位名称", trigger: 'blur' }],
        customerId: [{ required: true, message: "请选择所属客户", trigger: 'change' }],
        personNum: [{ required: true, trigger: 'blur', validator: personNumVal }],
        cityCodes: [{ required: true, trigger: 'blur', validator: cityVal }],
        professionCategory: [{ required: true, message: "请选择职位类别", trigger: 'blur' }],
        educationType: [{ required: true, message: "请选择学历要求", trigger: 'change' }],
        salaryMin: [{ required: true, trigger: 'blur', validator: salaryMinVal }],
        salaryMax: [{ required: true, trigger: 'blur', validator: salaryMaxVal }],
        experienceMin: [{ required: true, trigger: 'blur', validator: experienceMinVal }],
        experienceMax: [{ required: true, trigger: 'blur', validator: experienceMaxVal }],
        ageMin: [{ required: true, trigger: 'blur', validator: ageMinVal }],
        ageMax: [{ required: true, trigger: 'blur', validator: ageMaxVal }]
      },
      extraInfo: {
        priority: [{ required: true, message: "请选择优先级", trigger: 'change' }],
        projectStatus: [{ required: true, message: "请选择项目状态", trigger: 'change' }],
        customerContactsId: [{ required: true, message: "请选择客户联系人", trigger: 'change' }],
      },
      positionId: [{ required: true, message: "请选择类型", trigger: 'change' }],
      userId: [{ required: true, message: "请选择参与者", trigger: 'change' }],
      detailInfo: {
        projectDescription: [{ required: true, message: "请填写职位描述", trigger: 'blur' }],
        projectRequire: [{ required: true, message: "请填写任职要求", trigger: 'blur' }],
        interviewProcess: [{ required: true, message: "请填写面试流程", trigger: 'blur' }],
        Importance: [{ required: true, trigger: 'blur', validator: fileVal }]
      }
    }
    const data = reactive({
      isFull: false,
      isShowPer: false,
      loadingEdit: true,
      setItem: {
        age: { notNull: '', show: '', id: '' },
        attachment: { notNull: '', show: '', id: '' },
        city: { notNull: '', show: '', id: '' },
        clientContact: { notNull: '', show: '', id: '' },
        description: { notNull: '', show: '', id: '' },
        educationalRequirements: { notNull: '', show: '', id: '' },
        experience: { notNull: '', show: '', id: '' },
        interviewProcess: { notNull: '', show: '', id: '' },
        name: { notNull: '', show: '', id: '' },
        participator: { notNull: '', show: '', id: '' },
        priority: { notNull: '', show: '', id: '' },
        professionCategory: { notNull: '', show: '', id: '' },
        project_job_detail: {show: ''},
        project_job_info: {show: ''},
        project_project_info: {show: ''},
        recruitNum: { notNull: '', show: '', id: '' },
        requirements: { notNull: '', show: '', id: '' },
        salary: { notNull: '', show: '', id: '' },
        status: { notNull: '', show: '', id: '' },
      },
      ruleForm: {
        baseInfo: {
          title: '',
          ageMin: '',
          ageMax: '',
          cities: [],
          cityCodes: [],
          customerId: undefined,
          educationType: undefined,
          experienceMin: '',
          experienceMax: '',
          personNum: '',
          professionCategory: [],
          professionCategoryId: '',
          salaryMin: '',
          salaryMax: ''
        },
        extraInfo: {
          priority: undefined,
          projectStatus: undefined,
          customerContactsId: [],
          participatorsOld: [{
            positionId: undefined,
            userId: undefined,
            userName: '',
            positionName: '',
            headPhoto: '',
          }],
        },
        detailInfo: {
          projectDescription: '',
          projectRequire: '',
          interviewProcess: '',
          attachments: [] //接口返回附件
        },
      },
      uploadFlie: [], //新上传文件
      uploadType: 'jpg/jpeg/png/pdf/doc/docx', //上传-格式
      uploadSize: 10, //上传-大小
      uploadNum: 5, //上传数量
      clientSelect: [], //客户数据
      educationTypeSelect: [], //学历要求数据
      prioritySelect: [], //优先级数据
      statusSelect: [], //项目进展
      contactsSelect: [], //客户联系人
      participantTypeSelect: [], //参与者类型
      participantNameSelect: [], //参与者

      path:'addPosition',
      id:'', //职位Id
      title:'职位',
      addPar:props.addPar
    })
    const router = useRouter();
    const $bus = getCurrentInstance().appContext.config.globalProperties.$bus
    const {
      isMax,
      closeMoadl,
      maxOperation,
      minOperation,
      newData,
      maxIndex
    } = getAdd(data)
    const salaryMaxRef = ref();
    const salaryMinRef = ref();
    const experienceMinRef = ref();
    const experienceMaxRef = ref();
    const ageMinRef = ref();
    const ageMaxRef = ref();
    //输入校验
    const restrictInput = () => {
      data.ruleForm.baseInfo.personNum = validater.valZheng(data.ruleForm.baseInfo.personNum);
    }
    //最低年薪效验
    const salarySpceMin = () => {
      data.ruleForm.baseInfo.salaryMin = validater.checkNum2(data.ruleForm.baseInfo.salaryMin)
    }
    //最高年薪效验
    const salarySpceMax = () => {
      data.ruleForm.baseInfo.salaryMax = validater.checkNum2(data.ruleForm.baseInfo.salaryMax)
    }
    onMounted(async() => {
      if(newData.customerId){
        data.ruleForm.baseInfo.customerId = Number(newData.customerId);
        searchCompanyName(newData.customerId)
      }
      await fieldSettingsList();
      await selectSubCompanyName();
      await projectDropdownList();
      data.educationTypeSelect = await getDicList ('EDU_LEVEL',data.setItem.educationalRequirements.notNull) //学历
      data.prioritySelect = await getDicList ('PRIORITY_LEVEL',data.setItem.priority.notNull) //优先级
      data.statusSelect = await getDicList ('PROJECT_STATUS',data.setItem.status.notNull) //项目状态
      if (newData.id && maxIndex == -1) {
        await getPositionDetails();
      } else {
        data.loadingEdit = false;
      }
    })
    //查询字段列表
    const fieldSettingsList = () => {
      let params = {
        module: 'PROJECT'
      }
      fieldSettingsListApi(params).then(res => {
        if (res.success) {
          data.setItem = res.data;
        } else {
          message.warning(res.message);
        }
      })
    }
    //获取客户下拉框数据
    const selectSubCompanyName = () => {
      selectcustomerApi().then(res => {
        if (res.success) {
          data.clientSelect = res.data;
        } else {
          message.warning(res.message);
        }
      })
    }
    //内容发生改变
    const companyNameChange = (value) => {
      data.ruleForm.extraInfo.customerContactsId = [];
      searchCompanyName(value);
    }
    //客户下拉框内容发生改变，带出客户联系人
    const searchCompanyName = (value) => {
      let params = {
        customerId: value
      }
      selectCustomerContactsApi(params).then(res => {
        if (res.success) {
          data.contactsSelect = res.data;
        } else {
          message.warning(res.message);
        }
      })      
    }
    //新增联系人--弹窗展示
    const addItem = () => {
      data.isShowPer = true;
    }
    //新建联系人后处理- 传值
    const saveCantactHandle = (val) => {
      if (val) {
        searchCompanyName(data.ruleForm.baseInfo.customerId);
      }
    }
    //参与者-职位下拉框
    const projectDropdownList = () => {
      let param = {
        searchCondition: ''
      }
      projectDropdownListApi(param).then(res => {
        if (res.success) {
          data.participantTypeSelect = res.data;
        } else {
          message.warning(res.message);
        }
      })
    }
    //参与者-职位下拉框发生改变
    const searchpositionName = (value, index) => {
      getParticipantName(value, '')
      data.ruleForm.extraInfo.participatorsOld[index].userId = undefined;
    }
    //参与者-查询参与者用户
    const getParticipantName = (id, val) => {
      if (id) {
        let param = {
          searchCondition: val,
          positionId: id
        }
        if (newData.id) {
          param.projectId = newData.id;
        }
        userProjectApi(param).then(res => {
          if (res.success) {
            data.participantNameSelect = res.data;
          } else {
            message.warning(res.message);
          }
        })
      }
    }
    const filterOption = (input, option) => {
      return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    };
    //参与者-添加
    const addShare = () => {
      data.ruleForm.extraInfo.participatorsOld.push(
        { userId: undefined, userName: '', positionId: undefined, positionName: '', headPhoto: '' })
    }
    //参与者-删除
    const deleteShare = (index) => {
      data.ruleForm.extraInfo.participatorsOld.splice(index, 1)
    }
    //弹窗展示
    const moadlShow = ()=>{
      data.isShowPer = false;
    }
    const modalFormRef = ref();
    const loading = ref(false);
    //保存职位信息
    const handleSaveJob = () => {
      modalFormRef.value.validateFields().then(() => {
        if (data.setItem.participator.notNull && data.ruleForm.extraInfo.participatorsOld.length == 0) {
          message.warning('至少选择一位项目参与者')
          return
        }
        //设置城市    
        if (data.ruleForm.baseInfo.cities.length > 0) {
          let codes = [];
          data.ruleForm.baseInfo.cities.forEach(item => {
            codes.push(item.value);
          })
          data.ruleForm.cityCodes = codes;
        }
        //设置职类
        if (!validater.isEmpty(data.ruleForm.baseInfo.professionCategory)) {
          if (data.ruleForm.baseInfo.professionCategory.length > 0) {
            data.ruleForm.baseInfo.professionCategoryId = data.ruleForm.baseInfo.professionCategory[0].value;
          }
        }
        //参与者
        let userIdArr = [];
        if (data.ruleForm.extraInfo.participatorsOld.length > 0) {
          data.ruleForm.extraInfo.participatorsOld.forEach(item => {
            if (!validater.isEmpty(item.userId)) {
              userIdArr.push(item.userId)
            }
          })
        }

        data.ruleForm.extraInfo.participators = userIdArr;
        data.ruleForm.detailInfo.attachments = [...data.ruleForm.detailInfo.attachments, ...data.uploadFlie]
        data.ruleForm.extraInfo.customerContactIds = data.ruleForm.extraInfo.customerContactsId;
        loading.value = true;
        if (newData.id) { //编辑
          data.ruleForm.projectId = newData.id;
          projectUpdataeApi(data.ruleForm).then(res => {
            if (res.success) {
              message.success('编辑成功')
              goToLink();
              $bus.emit("changePositionMenu", true); 
              $bus.emit("changePositionList", true);
            } else {
              message.warning(res.message);
            }
            loading.value = false;
          })
        } else { //保存
          projectSaveApi(data.ruleForm).then(res => {
            if (res.success) {
              message.success('录入成功')
              goToLink();
              $bus.emit("changePositionMenu", true); 
              $bus.emit("changePositionList", true);
            } else {
              message.warning(res.message);
            }
            loading.value = false;
          })
        }
        
      })
      .catch((rep) => {
        modalFormRef.value.scrollToField(rep.errorFields[0].name);//滚动到对应字段位置
        if (rep.errorFields[0].name.includes('baseInfo')) {
          message.warning('请补全基本信息')
        } else if (rep.errorFields[0].name.includes('extraInfo')) {
          message.warning('请补全项目信息')
        } else if (rep.errorFields[0].name.includes('detailInfo')) {
          message.warning('请补全详细信息')
        }
      })
    }
    //关闭或跳转
    const goToLink = () => {
      if (isMax) { //大屏
        router.push({
          path: '/positions',
        });
      } else {
        closeMoadl();
      }
    }
    //查询职位详情
    const getPositionDetails = () => {
      projectDetailApi(newData.id).then(res => {
        data.loadingEdit = false;
        if (res.success) {
          data.ruleForm = res.data;
          //处理所属客户
          if (data.ruleForm.customerPermission !== 'CREATE_AND_EDIT_PROJECT') { //客户是否有编辑权限，并清空客户和客户联系人
            data.ruleForm.baseInfo.customer = {};
            data.ruleForm.extraInfo.customerContacts = {};
          } else {
            if (data.ruleForm.baseInfo.customer) {
              data.ruleForm.baseInfo.customerId = data.ruleForm.baseInfo.customer.id;
              searchCompanyName(data.ruleForm.baseInfo.customer.id)
            }
            //客户联系人
            if (data.ruleForm.extraInfo.customerContacts.length > 0) {
              data.ruleForm.extraInfo.customerContactsId = [];
              res.data.extraInfo.customerContacts.forEach(item => {
                data.ruleForm.extraInfo.customerContactsId.push(item.id);
              })
              // data.ruleForm.extraInfo.customerContactsId = data.ruleForm.extraInfo.customerContacts.id;
            }
          }
          //处理工作城市
          if (res.data.baseInfo.cities.length > 0) {
            let cityArr = [];
            let citys = [];
            data.ruleForm.baseInfo.cities.forEach(item => {
              cityArr.push(item.id);
              let obj = {
                value: item.id,
                label: item.name
              }
              citys.push(obj)
            })
            data.ruleForm.baseInfo.cities = citys;
            data.ruleForm.baseInfo.cityCodes = cityArr;
          }
          //职位类别
          if (res.data.baseInfo.professionCategory) {
            let obj = {
              label: res.data.baseInfo.professionCategory.name,
              value: res.data.baseInfo.professionCategory.id
            };
            data.ruleForm.baseInfo.professionCategory = [];
            data.ruleForm.baseInfo.professionCategory.push(obj)
          }  else {
            res.data.baseInfo.professionCategory = [];
          }
          //参与者
          if (!data.ruleForm.extraInfo.participators) {
            addShare();
          } else {
            data.ruleForm.extraInfo.participatorsOld = data.ruleForm.extraInfo.participators;
            let params = {
              searchCondition: ''
            }
            userSearchApi('search-condition',params).then(res => {
              if (res.success) {
                data.participantNameSelect = res.data;
              } else {
                message.message(res.message)
              }
            })
          }
        } else {
          message.warning(res.message)
        }
      })
    }
    //上传附件-子传值
    const fileUploadM = (arr, flg) => {
      if (flg == 1) { //进度条
        data.ruleForm.detailInfo.attachments.unshift(arr)
      } else if (flg == 2) {
        data.ruleForm.detailInfo.attachments.forEach(item => {
          if (item.uid == arr.uid) {
            item.attachmentUrl = arr.attachmentUrl
          }
        })
      }
    }
    //上传-删除后台文件
    const rightChaClick = (index) => {
      data.ruleForm.detailInfo.attachments.splice(index, 1);
    }
    //获取城市选择的值
    const searchCityhandle = (arr) => {
      data.ruleForm.baseInfo.cities = arr;
      data.ruleForm.baseInfo.cityCodes = [];
      if (arr.length > 0) {
        arr.forEach(item => {
          data.ruleForm.baseInfo.cityCodes.push(item.value)
        })
      }
    }
    //获取职位类别选择的值
    const searchTypehandle = (arr) => {
      data.ruleForm.baseInfo.professionCategory = arr;
    }
    return {
      rules,
      ...toRefs(data),
      getDicList,
      salaryMaxRef,
      salaryMinRef,
      experienceMinRef,
      experienceMaxRef,
      ageMinRef,
      ageMaxRef,
      fieldSettingsList,
      addShare,
      deleteShare,
      saveCantactHandle,
      projectDropdownList,
      getParticipantName,
      searchpositionName,
      filterOption,
      addItem,
      moadlShow,
      loading,
      modalFormRef,
      handleSaveJob,
      goToLink,
      getPositionDetails,
      fileUploadM,
      rightChaClick,
      isMax,
      closeMoadl,
      maxOperation,
      minOperation,
      newData,
      searchCityhandle,
      searchTypehandle,
      companyNameChange,
      restrictInput,
      salarySpceMin,
      salarySpceMax,
      selectSubCompanyName,
      searchCompanyName,
      validater,
    }
  },
})
</script>
<style scoped src="@/assets/css/add.css" >
</style>
<style scoped>
::v-deep .item-txt .ant-form-item-control-input-content,
::v-deep .peer-wrap .ant-form-item-control-input-content,
.peer-wrap {
  display: flex;
  align-items: center;
}
.right_text {
  margin-left: 8px;
  font-size: 14px;
  font-weight: 400;
  color: #33383D;
  line-height: 16px;
}
::v-deep .peer-wrap {
  justify-content: space-between;
}
::v-deep .addContent .peer-wrap .ant-form-item {
  flex: 1;
  /* width: 47.8%;
  min-width: 47.8%;
  max-width: 47.8%; */
  width: calc(50% - 14px);
  min-width: calc(50% - 14px);
  max-width: calc(50% - 14px);
}
.center_text {
  display: block;
  line-height: 32px;
  color: #33383D;
  margin: 0 8px 16px;
  width: 4px;
}
.tow-item-box {
  margin-bottom: 0;
}
::v-deep .item-add-five-box .ant-form-item-label {
  width: 84px!important;
  padding-right: 10px!important;
}

.participant-warp {
  display: flex;
  align-items: center;
}
.participant-warp1 {
  display: flex;
  align-items: center;
}
.participant-warp .icon-add {
  margin-left: 12px;
  cursor: pointer;
  margin-bottom: 16px;
}
.icon-add:hover .blur-svg {
  fill: #507AFD;
}
.participant-warp .icon-del {
  margin-left: 10px;
  cursor: pointer;
  margin-bottom: 16px;
}
.icon-del:hover .blur-svg {
  fill: #507AFD;
}
::v-deep .upload-box .ant-form-item-control-input-content {
  display: flex;
  align-items: center;
}
.upload-tip {
  height: 18px;
  font-size: 14px;
  font-weight: 400;
  color: #4F5B6E;
  line-height: 14px;
  margin-left: 16px;
}
.item-width-box.ant-form-item {
  flex: 1;
  width: 30%!important;
  min-width: 30%!important;
  max-width: 30%!important;
  margin-right: 8px;
}
::v-deep .addContent .select-center-box.ant-form-item {
  flex: 1;
  width: calc(100% - 30% - 74px)!important;
  min-width: calc(100% - 30% - 74px)!important;
  max-width: calc(100% - 30% - 74px)!important;
}
::v-deep .addContent .select-conter-box1.ant-form-item {
  flex: 1;
  width: calc(100% - 30% - 40px)!important;
  min-width: calc(100% - 30% - 40px)!important;
  max-width: calc(100% - 30% - 40px)!important;
}
.item-xing {
  display: inline-block;
  margin-right: 4px;
  color: #ff4d4f;
  font-size: 14px;
  font-family: SimSun, sans-serif;
  line-height: 1;
  content: '*';
}
.add-custer-link:hover {
  color: #507AFD;
}
</style>
